// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "submit-4_ukK";
var _3 = "controls-2m5aN";
export { _1 as "__esModule", _2 as "submit", _3 as "controls" }
export default { "__esModule": _1, "submit": _2, "controls": _3 }
